import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/coupon/:id',
  title: 'Editar cupom',
  endpoint: '/app/coupon',
  breadcrumbs: [{ label: '', location: '' }],
}
